<section class="af-section">
  <header class="af-section__head">
    <h6 class="af-section__title">{{ headingText }}</h6>
    <span class="af-section__count">{{ dataSource?.length || 0 }}</span>
  </header>

  <!--
    A plain list rather than a mat-table: the three sections share one set of
    column labels on the parent, which a per-section table header cannot do, and
    the grid tracks come from the same `--tr-file-cols` token so every row still
    lines up with the labels.
  -->
  <div class="af-rows" role="list" *ngIf="dataSource?.length; else noFiles">
    <div class="af-row" role="listitem" *ngFor="let element of dataSource">
      <span class="af-row__name"
            [title]="showdocumentTypeName
              ? (element.documentTypeName ?? 'No details')
              : ((element.imageCount > 0 ? '(' + element.imageCount + ') ' : '') + element.mimeType + (element.imageCount > 1 ? 's' : ''))">
        <!-- X-Ray Report 1 -->
        <ng-container *ngIf="showdocumentTypeName; else mimeType">
          {{ element.documentTypeName ?? 'No details' }}
        </ng-container>

        <ng-template #mimeType>
          {{ element.imageCount > 0 ? "(" + element.imageCount + ")" : "" }}
          {{ element.mimeType }}{{ element.imageCount > 1 ? "s" : "" }}
        </ng-template>
      </span>

      <span class="af-row__meta">
        <span class="af-row__by">{{ element.submittedBy }}</span>
        <span class="af-row__date">{{ element.date | date : "d MMM y, h:mm a" }}</span>
      </span>

      <span class="af-row__act">
        <button class="btn btn-success open-button" (click)="emitOpenButtonClicked(element, element.form)"
                [disabled]="!isEnabledAction(element)">
          {{ openButtonText }}
        </button>
        <button *ngIf="isSalesCompany()" class="btn btn-outline-secondary btn-download"
                title="Download"
                (click)="emitDownloadButtonClicked(element.studyFileIds)">
          <i class="fa fa-download"></i>
        </button>
      </span>
    </div>
  </div>

  <ng-template #noFiles>
    <p class="af-section__empty">None submitted</p>
  </ng-template>

  <!--
    These notices used to live in a mat-table footer row, which meant they only
    rendered while the table had a datasource to draw a footer for. They are
    status messages about the group, not about a row, so they sit below it now
    and read the same in the empty state. The `!isSalesCompany()` guard is the
    one that used to sit on the *matFooterRowDef.
  -->
  <div class="af-section__notes" *ngIf="!isSalesCompany()">
    <ng-container *ngIf="enforceDeclaration">
      <!--Declare client name to view-->
      <span class="af-section__note" *ngIf="!isEnabledDeclarationTextBox()">Viewing is not allowed at this time.</span>
      <span class="af-section__note" *ngIf="isEnabledDeclarationTextBox() && !disclosedClient && !viewXrayValidationMessage">Declare client name to view</span>
    </ng-container>

    <div class="warning-panel-sm" *ngIf="!isViewXraysAllowed && viewXrayValidationMessage">
      <span class="icon">⚠️</span>
      <span class="message">
        <ng-container>
          <div [innerHTML]="viewXrayValidationMessage"></div>
        </ng-container>
      </span>
      <button class="dismiss-btn" onclick="this.parentElement.style.display='none'">✖</button>
    </div>
  </div>
</section>
